import React from 'react';
import withSizes from 'react-sizes';

import { BannerDescription } from './BannerDescription/BannerDescription.jsx';
import {
  RollUpClickableTitle,
  WrapBannerImageWithHref,
} from '../../../../shared/index.jsx';

const mapSizesToProps = ({ width }) => ({
  winW: width
})

class NewGermanyCinema26 extends React.Component {
  bannerImgSrc() {
    return this.props.winW >= 1024
      ? '/img/2026/11/NewGermanyCinema26/dt.jpg'
      : '/img/2026/11/NewGermanyCinema26/mob.jpg'
  }

  promoLink = '/movie/351193'

  render() {
    return (
      <div className='mp__sertificat'>
        <div className='wd'>
          <div className='sertificat'>
            <WrapBannerImageWithHref href={this.promoLink} src={this.bannerImgSrc()} />
            <RollUpClickableTitle title='Нове Німецьке Кіно з 12 до 18 листопада у кінотеатрі «Жовтень»' />
            <BannerDescription promoLink={this.promoLink} />
          </div>
        </div>
      </div>
    )
  }
}

export default withSizes(mapSizesToProps)(NewGermanyCinema26)


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/items/NewGermanyCinema26/impl/NewGermanyCinema26.jsx